var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9751 19.66L19.3883 22.4162C19.4404 22.4747 19.5048 22.5208 19.577 22.5511C19.6491 22.5815 19.7271 22.5953 19.8053 22.5916C19.8835 22.5879 19.9598 22.5668 20.0288 22.5298C20.0977 22.4928 20.1576 22.4408 20.2038 22.3777L25.1038 15.5947",
    stroke: "#006EC2",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.062 30.1687C3.5 28.1195 3.5 26.569 3.5 19.9697C3.5 13.3705 3.5 10.07 6.062 8.02073C8.6275 5.96973 12.7505 5.96973 21 5.96973C29.2495 5.96973 33.3742 5.96973 35.9362 8.02073C38.4982 10.0717 38.5 13.3705 38.5 19.9697C38.5 26.569 38.5 28.1195 35.9362 30.1687C33.376 32.2197 29.2495 32.2197 21 32.2197C16.6075 32.2197 14.35 35.2612 10.5 37.4697V31.8487C8.5855 31.5635 7.17675 31.0612 6.062 30.1687Z",
    stroke: "#006EC2",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures5);
export default __webpack_public_path__ + "static/media/features5.69f683779f9c36facd19ce46a5c5bf59.svg";
export { ForwardRef as ReactComponent };